import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import './index.css';
import App from './App';
import { StepSuccessComponent } from './StepSuccessComponent';
import { StepDocUploadComponent } from './StepDocUploadComponent';
import { StepPendingComponent } from './StepPendingComponent';
import { StepFirstResponderPersonalInfoComponent } from './StepFirstResponderPersonalInfoComponent';

setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messages: {
        "organization" : "Organization",
        "firstName" : "First Name",
        "lastName" : "Last Name",
        "emailAddress" : "Email Address",
        "postalCode" : "Home Zip Code",
        "errorId": {
            "internalServerError": "Internal server error",
            "noRemainingRewardCodes": "Sorry, this offer is closed and we can't verify you at this time. Please try again later.",
            "noProgram": "No program found",
            "noVerification": "No verification found",
            "invalidProgram": "Invalid program",
            "invalidStep": "Invalid step",
            "invalidMilitaryStatus": "Invalid military status, expected one of [ACTIVE_DUTY, VETERAN, RESERVIST, MILITARY_RETIREE]",
            "invalidFirstResponderStatus": "Invalid first responder status, expected one of [POLICE, EMT, FIREFIGHTER]",
            "invalidOrganization": "You must select an organization from the list",
            "invalidFirstName": "Invalid first name",
            "invalidLastName": "Invalid last name",
            "invalidBirthDate": "Invalid birth date",
            "invalidEmail": "Invalid email",
            "invalidPostalCode": "Invalid postal code",
            "underagePerson": "Underage",
            "outsideAgePerson": "Age outside allowed range",
            "futureBirthDate": "Future birthdate",
            "unsupportedDocMimeType": "One or more files is an unsupported format",
            "invalidFileSizeEmpty": "One or more files is empty",
            "invalidFileSizeMax": "One or more files is too large (max: 10MB)",
            "invalidNumberOfFiles": "Maximum number of files exceeded (max: 5)",
            "invalidDocUploadToken": "Provided document upload token is not valid",
            "verificationLimitExceeded": "Verification limit exceeded",
            "docReviewLimitExceeded": "Document review limit exceeded",
            "maxMetadataValuesExceeded": "Maximum number of metadata values exceeded",
            "maxMetadataLengthExceeded": "Maximum length of metadata value exceeded",
            "unknownError": "Unknown Error",
            "invalidRequest": "Invalid request",
            "invalidApiToken": "Provided API token was invalid or empty",
            "simulatedError": "This is a simulated error",
            "notFound": "Not found"
        },
        "step" : {
            "personalInfo" : {
                "subtitle" : "Confirm your eligibility by simply completing the form below.",
                "title" : "Verify your details",
            },
            "docUpload" : {
                "fileInstructions" : "Choose file",
                "submitButtonLabel" : "SUBMIT FOR REVIEW",
            }
        }
    }
});

// @ts-ignore
overrideComponent('StepFirstResponderPersonalInfoComponent', StepFirstResponderPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepPendingComponent', StepPendingComponent);

ReactDOM.render(<App />, document.getElementById('root'));
